import ReportsPageSubmitSectionView from './reports-page-submit-section-view'

export default ReportsPageSubmitSectionView
